import { gql } from '@apollo/client';

export const UPDATE_EVENT_NAME = gql`
  mutation updateEventName($customEventName: String!, $eventUuid: String!) {
    updateCustomEventName(
      data: { customEventName: $customEventName }
      eventUuid: $eventUuid
    ) {
      custom_event_name
    }
  }
`;
